import { render } from "./ContactDetailsComponent.vue?vue&type=template&id=9d8e59fc"
import script from "./ContactDetailsComponent.vue?vue&type=script&lang=js"
export * from "./ContactDetailsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__